import { ITaskTableItem } from './tasks-list-table.interfaces';
import { ProcessTaskAssignEnum, ProcessTaskStatusesEnum } from '@thinknet-gmbh/platform-common';

export const getAssignTo = ({
  assignTo,
  responsiblePersons,
  company,
  department,
  job,
}: ITaskTableItem) => {
  if (assignTo === ProcessTaskAssignEnum.PERSONS) {
    return responsiblePersons
      ?.map(({ profile }) => {
        return profile?.displayName;
      })
      .join(', ');
  }
  if (assignTo === ProcessTaskAssignEnum.DEPARTMENT) {
    return `${company?.name}, ${department?.name}`;
  }
  if (assignTo === ProcessTaskAssignEnum.JOB) {
    return job?.title;
  }
};

export const getTaskStatusClass = ({ status, overdue }: ITaskTableItem) => {
  if (status === ProcessTaskStatusesEnum.OPEN && !overdue) {
    return 'task-lightYellow';
  }

  if (status === ProcessTaskStatusesEnum.OPEN && overdue) {
    return 'task-lightRed';
  }

  if (status === ProcessTaskStatusesEnum.COMPLETED) {
    return 'task-lightGreen';
  }

  return '';
};
